import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Boxes, UserPlus, DollarSign, Mail, Star, MessageSquare, TrendingUp, RefreshCw, Check } from "lucide-react";
import Logo from "@/components/Logo";

const BENEFITS = [
  ["Move Excess Inventory", Boxes], ["Acquire Customers", UserPlus], ["Generate Upsell Revenue", DollarSign],
  ["Build Your Email List", Mail], ["Generate Reviews", Star], ["Gain Product Feedback", MessageSquare],
  ["Increase Brand Awareness", TrendingUp], ["Create Repeat Buyers", RefreshCw],
];

export default function BrandsLanding() {
  return (
    <div>
      <section className="relative overflow-hidden grain" style={{ background: "linear-gradient(160deg,#FFF4E6 0%,#FAFAF9 100%)" }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-20 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white friib-shadow text-xs font-bold text-stone-600 mb-5">For Brands</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-stone-900 leading-[1.05]">Stop letting inventory<br />collect dust.</h1>
          <p className="mt-5 text-lg text-stone-600 max-w-xl mx-auto">Turn excess inventory into customers, data, reviews and revenue.</p>
          <Link to="/register" className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-white text-lg transition-transform hover:scale-105" style={{ background: "var(--friib)" }}>List Your First Friib <ArrowRight size={18} /></Link>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="rounded-3xl bg-white border border-stone-100 friib-shadow p-8">
            <h3 className="font-display text-xl font-bold text-stone-900 mb-4">The old playbook</h3>
            <ul className="space-y-3 text-stone-500">{["Discount inventory", "Liquidate it", "Pay storage fees", "Write it off"].map((t) => <li key={t} className="flex items-center gap-2"><span className="w-5 h-5 rounded-full bg-red-100 grid place-items-center text-red-500 text-xs">✕</span> {t}</li>)}</ul>
          </div>
          <div className="rounded-3xl p-8 text-white" style={{ background: "var(--ink)" }}>
            <h3 className="font-display text-xl font-bold mb-4">The Friib way</h3>
            <p className="text-stone-300 mb-4">Give the product away strategically and acquire a customer — with their profile, email, a review, and immediate upsell revenue.</p>
            <p className="font-bold">Your unsold inventory already cost you money. Friib turns it into customer acquisition.</p>
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h2 className="font-display text-3xl font-bold text-stone-900 text-center mb-10">Everything you get from one Friib</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {BENEFITS.map(([t, Icon]) => (
            <div key={t} className="rounded-2xl bg-white border border-stone-100 friib-shadow p-6">
              <span className="w-11 h-11 grid place-items-center rounded-full mb-3" style={{ background: "var(--friib-light)" }}><Icon size={20} style={{ color: "var(--friib)" }} /></span>
              <p className="font-display font-bold text-stone-900">{t}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-16 text-center">
        <div className="rounded-3xl p-10 text-white relative overflow-hidden" style={{ background: "var(--friib)" }}>
          <div className="grain absolute inset-0 opacity-20" />
          <h2 className="font-display text-3xl font-extrabold mb-3 relative z-10">Ready to acquire your next 1,000 customers?</h2>
          <Link to="/merchant" className="relative z-10 inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-stone-900 bg-white mt-2">Open Merchant Portal <ArrowRight size={18} /></Link>
        </div>
      </section>
    </div>
  );
}
